var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFire = function SvgFire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 7 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.833.167A.333.333 0 0 0 2.5.5c0 1.686-2.333 3-2.333 5.333 0 1.773 1.92 2.919 2.597 2.993a.333.333 0 0 0 .28-.584V8.24c-.304-.246-.877-.96-.877-1.611 0-1.07 1-1.463 1-1.463-.57 1.613 1.298 1.808 1.674 3.405a.333.333 0 0 0 .539.184c.054-.035 1.453-.961 1.453-2.923 0-.8-.4-2.176-.688-2.785l-.001-.002v-.002a.333.333 0 0 0-.638.062v.001c-.001.004-.154.684-.673 1.06C4.833 2.597 3.7.974 3.102.303a.33.33 0 0 0-.269-.136"
  })));
};
export default SvgFire;